import PRNG from './PRNG';
import adjective from './equalOddsTables/adjective.json';
import nameTemplate from './equalOddsTables/nameTemplate.json';
import object from './equalOddsTables/object.json';
import noun from './equalOddsTables/noun.json';
import { EventCrucible, EventCrucibleList } from './traits/eventCrucibles';
import eventCrucibles from './traits/eventCrucibles.json';
import extras from './cruciblePieces/extras/extras.json';

function applyReplacements(
  template: string,
  replacements: { [key: string]: string }
) {
  let output = template;
  for (const [replacementName, replacementValue] of Object.entries(
    replacements
  )) {
    output = output.replace(
      new RegExp(`\\{\\{${replacementName}}}`, 'g'),
      replacementValue
    );
  }
  return output;
}

export default function getName(
  crucibleId: string,
  mintBlockNumber: number,
  mintTimestamp: number
) {
  if (crucibleId in eventCrucibles) {
    const eventCruciblesList: EventCrucibleList = eventCrucibles;
    const eventCrucible: EventCrucible = eventCruciblesList[crucibleId];
    if (eventCrucible.name) return eventCrucible.name;
  }

  const prng = new PRNG(crucibleId, mintBlockNumber, mintTimestamp);

  const pickedAdjective = adjective[prng.randomInt('name', adjective.length)];
  const pickedObject = object[prng.randomInt('name', object.length)];
  const pickedNoun = noun[prng.randomInt('name', noun.length)];
  const pickedNameTemplate =
    nameTemplate[prng.randomInt('name', nameTemplate.length)];

  const replacements = {
    pickedAdjective,
    pickedNoun: pickedObject,
    pickedProperNoun: pickedNoun
  };

  // Apply special prefix for Crucibles minted before Aludel v1 was shut down
  if (mintBlockNumber <= extras.arcaneRings.blockNumberLimit) {
    return `${extras.arcaneRings.titlePrefix} ${applyReplacements(
      pickedNameTemplate,
      replacements
    )}`;
  } else {
    return applyReplacements(pickedNameTemplate, replacements);
  }
}
